import React, {Fragment, useEffect, useState} from 'react';
import '@components/module-components/DetailedView/detailed-view.scss';
import '@components/module-components/DetailedView/journey.scss';
import co2icon from '@assets/images/icons/co2-green.svg';
import energyicon from '@assets/images/icons/energy-orange.svg';
import watericon from '@assets/images/icons/water-blue.svg';
import {useDispatch, useSelector} from 'react-redux';
import {getParams, translate} from '@src/helpers';
import {Translations} from '@constants/translate';
import {useHistory, useLocation} from 'react-router-dom';
import {Grade} from '@src/types';

import Geocode from "react-geocode";
import {getInputProducts} from "@api/Common";
import DetailViewProcess from "@components/module-components/DetailedView/DetailViewProcess";
import {ENV} from "@environments/environment";
import _ from "lodash-es";

const GG_KEY = ENV.GG_KEY;

const getGrade = (type: any, dataEco: any) => {
  const eco = dataEco.find((eco_score: any) => eco_score.type === type);
  if (eco) {
    return eco.grade || Grade.NONE
  }
  return Grade.NONE;
};

const getCountryCode = (addrComponents: any[]) => {
  const cc = addrComponents.find((country: any) => country.types.includes('country'));
  return cc ? cc.short_name.toLowerCase() : '';
}

const DetailedViewV2 = ({dataMap, dataDetail, dataDetailRaw, isShowEco = 0}: any) => {
  const langData = useSelector((state: any) => state.currentLanguage) as any;
  const {
    order = '', brand = ''
  } = getParams();
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  Geocode.setApiKey(GG_KEY);
  const [list, setList] = useState([] as any)
  const [seen, setSeen] = useState(false)
  const [clickedUid, setClickedUid] = useState(null)
  const togglePop = (uid) => {
    setClickedUid(uid);
    setSeen(!seen)
  };

  useEffect(() => {
    const formatData = async () => {
      const listTemp: any = [];
      const lengthPos = dataDetail.length;
      for (let index = 0; index < lengthPos; index++) {
        const posListTemp: Array<any> = [];
        const lengthPosition = dataDetail[index].length;

        for (let idx = 0; idx < lengthPosition; idx++) {
          let country_code: any = ''
          try {
            if (dataDetail[index][idx].process_lat && dataDetail[index][idx].process_long) {
              const res = await Geocode.fromLatLng(dataDetail[index][idx].process_lat, dataDetail[index][idx].process_long);
              country_code = getCountryCode(res.results[0].address_components);
            }

            const {data: {input_products}} = await getInputProducts(dataDetail[index][idx].uid);
            dataDetail[index][idx].products = input_products.value;
            posListTemp.push({
              ...dataDetail[index][idx],
              country_code
            })


          } catch (error) {
            console.log("data", error, dataDetail[index][idx]);
          }

        }

        listTemp.push(posListTemp);
      }
      setList(listTemp);
    }
    formatData();
  }, [dataDetail]);

  return (

    <Fragment>


      <div className="detailed-view">
        {isShowEco === 1 && <div className="detailed-view_desc">
            <div className="icon-text">
                <img src={co2icon} alt=""/>
                <div
                    className="icon-text_content">{translate(langData.localize, Translations["FIP.BRAND.ORDER.CO2_EMISSION"])}</div>
            </div>
            <div className="icon-text">
                <img src={energyicon} alt=""/>
                <div
                    className="icon-text_content">{translate(langData.localize, Translations["FIP.BRAND.ORDER.ENERGY_USED"])}</div>
            </div>
            <div className="icon-text">
                <img src={watericon} alt=""/>
                <div
                    className="icon-text_content">{translate(langData.localize, Translations["FIP.BRAND.ORDER.WATER_USED"])}</div>
            </div>
        </div>
        }

        <div className="journey-container">

          <div className="journey-table">

            {/*<div className="journey-table-header">*/}

            <div className={"journey-table-header"}>

              <div>{translate(langData.localize, "LABEL.B2C.DETAIL_VIEW.HEADER.PROCESS")}</div>
              <div>{translate(langData.localize, "LABEL.B2C.DETAIL_VIEW.HEADER.DATE_TIME")}</div>
              <div>{translate(langData.localize, "LABEL.B2C.DETAIL_VIEW.HEADER.MANUFACTURER")}</div>
              <div>{translate(langData.localize, "LABEL.B2C.DETAIL_VIEW.HEADER.COUNTRY")}</div>
              <div>&nbsp;</div>
            </div>

            {/*</div>*/}

            <div className="journey-table-body">

              {
                dataDetailRaw.map(item => {
                    return (
                      <DetailViewProcess key={item.process_id}
                                         data={item}
                                         dataMap={dataMap}
                                         classNameWrapper={"lv0"}
                                         className={"lv0"}
                      />
                    )
                  }
                )
              }

            </div>

          </div>


        </div>

      </div>

    </Fragment>
  )
    ;
}

export default DetailedViewV2;
